import { render } from "./CreateView.vue?vue&type=template&id=0b19dee8"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"

import "./CreateView.vue?vue&type=style&index=0&id=0b19dee8&lang=css"

import exportComponent from "C:\\Users\\Admin\\NodeProjects\\FibreFrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__